import React from "react";
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  ConfirmModal: {
    width: '250px',
    height: '120px',
  
    display: 'flex',
    flexDirection: 'column',
    width: 'var(--width)',
    height: 'var(--height)',
    position: 'fixed',
    top: 'calc(100vh / 2 - var(--height) / 2)',
    left: 'calc(100vw / 2 - var(--width) / 2)',
    borderRadius: '10px',
    boxShadow: '-1px 0 15px 0 rgba(34, 33, 81, 0.01), 0px 15px 15px 0 rgba(34, 33, 81, 0.25)',
    padding: '15px',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    textAlign: 'center',
    zIndex: '1',
  
    'h1': {
      flex: '1',
      fontSize: '16px',
      fontWeight: 'normal',
      lineHeight: '20px',
    },
  
    'button': {
      width: '50px',
      height: '23px',
      background: '#242836',
      color: '#f6f8ff',
      border: 'none',
      borderRadius: '3px',
      margin: '0 5px',
      cursor: 'pointer',
  
      '&:hover': {
        backgroundColor: '#2f3545'
      }
    }
  }
}));

export const ConfirmModal = ({
  onConfirm,
  onDeny,
  children
}) => {
  const styles = useStyles();
  return (
  <div className={styles.ConfirmModal}>
    <h1>{children}</h1>
    <div>
      <button onClick={onConfirm}>Yes</button>
      <button onClick={onDeny}>No</button>
    </div>
  </div>
)};
